// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__10Dli","bigColWidth":"Table_bigColWidth__3Z80j","biggerColWidth":"Table_biggerColWidth__3Lrvu","row":"Table_row__1IHAd","col":"Table_col__2l87N"};